import { setError } from 'client/modules/App/AppActions';
import { connect } from 'react-redux';
import {
  customMailServiceApikeyChange,
  customMailServiceDomainChange,
  customMailServiceFromEmailChange,
  customMailServiceTypeChange,
  setSettings,
  useCustomMailServiceChange as setUseCustomMailService,
} from '../../SettingsActions';
import { getCustomMailService, isUseCustomMailService } from '../../SettingsReducer';

import MailProviderPage from './MailProviderPage';

const mapStateToProps = state => {
  return {
    customMailService: getCustomMailService(state),
    useCustomMailService: isUseCustomMailService(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetSettings: (_, settings, getErrorMessage) => {
      dispatch(setSettings(settings, getErrorMessage));
    },
    onMailServiceTypeInputChange: event => {
      dispatch(customMailServiceTypeChange(event.target.value));
    },
    onMailServiceApiKeyInputChange: event => {
      dispatch(customMailServiceApikeyChange(event.target.value));
    },
    onMailServiceDomainInputChange: event => {
      dispatch(customMailServiceDomainChange(event.target.value));
    },
    onMailServiceFromEmailInputChange: event => {
      dispatch(customMailServiceFromEmailChange(event.target.value));
    },
    onHandleToggleCustomMail: newValue => {
      dispatch(setUseCustomMailService(newValue));
    },
    setError: error => {
      dispatch(setError(error));
    },
  };
};

const MailProviderPageContainer = connect(mapStateToProps, mapDispatchToProps)(MailProviderPage);

export default MailProviderPageContainer;
